import { Injectable } from '@angular/core';

import { setInitialStoreState } from '../../../../../common/utils';
import { UserPredictionsListFacade } from './user-predictions-list.facade';

@Injectable({
  providedIn: 'root',
})
export class UserPredictionsListGuard  {
  constructor(private userPredictionsListFacade: UserPredictionsListFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.userPredictionsListFacade);
  }
}
